import { render, staticRenderFns } from "./flowNewsAuditList.vue?vue&type=template&id=639a5302&"
import script from "./flowNewsAuditList.vue?vue&type=script&lang=js&"
export * from "./flowNewsAuditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports